import * as tslib_1 from "tslib";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtendzApiItemHostComponent } from './extendz-api-item-host.component';
import { ExtendzApiItemModule } from '../api-item/extendz-api-item.module';
var ExtendzApiItemHostModule = /** @class */ (function () {
    function ExtendzApiItemHostModule() {
    }
    ExtendzApiItemHostModule = tslib_1.__decorate([
        NgModule({
            imports: [CommonModule, ExtendzApiItemModule],
            exports: [ExtendzApiItemHostComponent],
            declarations: [ExtendzApiItemHostComponent],
        })
    ], ExtendzApiItemHostModule);
    return ExtendzApiItemHostModule;
}());
export { ExtendzApiItemHostModule };
//# sourceMappingURL=extendz-api-item-host.module.js.map